import { forwardRef } from 'react';
import { Pressable, View } from 'react-native';
import { TextFieldRef } from '../../Core/TextInput/TextField';
import { Typography } from '../../Core/Typography/Typography';
import { cn } from '../../lib/utils';
import { AssetFieldProps } from './AssetField.types';
import { AssetAmountInput } from './components/AssetAmountInput/AssetAmountInput';
import { AssetSelect } from './components/AssetSelect/AssetSelect';

export const AssetField = forwardRef<TextFieldRef, AssetFieldProps>(
  (
    {
      assetCode,
      assetIconComponent,
      assetIconProps,
      assetSelectable = true,
      assetPlaceholder,
      title,
      amountReadonly = false,
      amount,
      hasError = false,
      infoText,
      showPlusMinusButtons,
      percentageButtons,
      className,
      onPress,
      onPlusPressed,
      onMinusPressed,
      onValueChanged,
      onPercentageButtonPressed,
      onFocus,
      onBlur,
      onInfoTextPressed,
    },
    ref,
  ) => {
    return (
      <View className={className}>
        <View className="flex flex-row w-full">
          <AssetSelect
            iconProps={assetIconProps}
            selectedAssetCode={assetCode}
            title={title}
            placeholder={assetPlaceholder}
            rounded={'left'}
            onPress={onPress}
            iconComponent={assetIconComponent}
            disabled={!assetSelectable}
            showDropdownIcon={assetSelectable}
          />
          <AssetAmountInput
            ref={ref}
            className="flex-1"
            hasError={hasError}
            value={amount}
            onValueChanged={onValueChanged}
            onPlusPressed={onPlusPressed}
            onMinusPressed={onMinusPressed}
            readonly={amountReadonly}
            showPlusMinusButtons={showPlusMinusButtons}
            assetCode={assetCode}
            percentageButtons={percentageButtons}
            onPercentageButtonPressed={onPercentageButtonPressed}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        </View>

        {infoText && (
          <Pressable
            className={cn(
              onInfoTextPressed != undefined && 'active:opacity-20',
            )}
            onPress={() => onInfoTextPressed?.()}>
            <Typography
              size="small"
              className={cn('text-right mt-3', hasError && 'text-error')}>
              {infoText}
            </Typography>
          </Pressable>
        )}
      </View>
    );
  },
);
